import Button from '../../../components/CustomButtons/ButtonTS';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import React from 'react';
import { INode } from '../../helpers/interfaces';
import Tooltip from "@material-ui/core/Tooltip";

interface INodeImagesIconProps {
	show: boolean;
	node: INode;
	showNodeImagesCard(node: INode): void;
}

export const NodeImagesIcon = (props: INodeImagesIconProps) => {
	const { show, showNodeImagesCard, node } = props;
	if (!show) {
		return null;
	}
	return (
	    <Tooltip title="Images">
            <div>
                <Button
                    color={'info'}
                    simple
                    justIcon
                    onClick={() => showNodeImagesCard(node)}
                    data-testid='baseIcon'
                >
                    <PhotoCamera />
                </Button>
            </div>
		</Tooltip>
	);
};

export default NodeImagesIcon;
